(function () {
    "use strict";
    
    function simple_atc() {
        const style = document.createElement("style");
        style.textContent = `
            .product-add-to-cart-sticky{
                box-shadow: none !important;
                border-radius: 10px !important;
                padding: 0 !important;
            }
            .sticky-open{
                text-align: center !important;
            }
            .single-add-to-cart-button{
                width: 100% !important;
            }
            .product-form{
                margin-top: 0 !important;
            }
            .button{
                padding: 7px 30px !important;
            }
            .product-add-to-cart-sticky--inner{
                text-align: center !important;
            }
            `;
        document.head.append(style);

        // Select the <product-form> element
        const productForm = document.querySelector(".product-form[data-sticky='1']");
        const innerATC = document.querySelector(".product-add-to-cart-sticky--inner");
        const contentContainer = document.querySelector(".product-add-to-cart-sticky--content");

        // Clear all the children node within .product-add-to-cart-sticky--inner with new content
        innerATC.innerHTML = `<span class="single-add-to-cart-button--text">Add to cart</span>`;

        // Add additional classes
        innerATC.classList.add("single-add-to-cart-button", "button", "outline", "open-button");

        innerATC.after(productForm);

        const fakeButton = document.querySelector(".open-button");
        const atcHolder = document.querySelectorAll(".add_to_cart_holder")[1];
        
        // Initially display fakeButton and hide atcHolder
        atcHolder.style.display = "none";

        // Add click event listener to fakeButton
        innerATC.addEventListener("click", () => {

            // Hide fakeButton and show atcHolder
            fakeButton.style.display = "none";
            atcHolder.style.display = "block";
            contentContainer.style.height = "auto";
            contentContainer.style.display = "block";
        });

        // Listen for the completion of the add-to-cart action
        atcHolder.addEventListener("click", () => {
            // Simulate a delay for the container close action
            setTimeout(() => {
                // Reset to original state
                atcHolder.style.display = "none";
                fakeButton.style.display = "block";
                contentContainer.style.height = "0";
                contentContainer.style.display = "none";
            }, 2000); // Adjust timeout to match the time needed for the action to complete
        });

        const observer = new MutationObserver(() => {
            const stickyVisible = document.querySelector(".sticky--visible");
            if (!stickyVisible) {
                // Reset to original state if sticky--visible is null
                atcHolder.style.display = "none";
                fakeButton.style.display = "block";
                contentContainer.style.height = "0";
                contentContainer.style.display = "none";
            }
        });

        observer.observe(document.querySelector("product-add-to-cart-sticky"), {
            attributes: true,
        });        
    }
      
    function onDOMContentLoaded() {
      simple_atc();
    }
    
    if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
    once: true,
    });
    } else {
    onDOMContentLoaded();
      }
})();